query legalConsents($id: String!) {
  company(id: $id) {
    id
    country
    legalConsents {
      identifier
      acceptedAt
    }
    state {
      stringValues
    }
  }
}
